export const SIP_HEADER_AGENT_KEY = 'User-Agent';
export const SIP_HEADER_METADATA_KEY = 'P-SVRS-SInfo';
export const SDP_HEADER_METADATA_KEY = 'X-SVRS-SINFO';
export const HEADER_METADATA_VALUE_KEY = 'SInfo:';
